import { v4 as uuid } from 'uuid';
import { handleTree } from '../utils/dict';
import baseConfig from '../router/RouterMap';
const customMenu = [
]
const resetNodeMap = (tree, map, path) => {
    if (!map) map = {};
    if (!path) path = '';
    for (const node of tree) {
        const p = ((path ? path + '/' : '') + node.component).replace(/\/{2,}/g, '/').replace(/^\s+|\s+$/g, '');
        // if (/contract\/list/.test(p))
        //     console.log('check permission', p)
        let ps = map[p];
        if (!ps) map[p] = node;
        else if (ps instanceof Array) ps.push(node);
        else map[p] = [ps, node];
        if (node.children) resetNodeMap(node.children, map, p);
    }
    return map;
}
const customPath = customMenu.map(it => { return it.path })
const resetMenu = (data) => {
    let menu = data
    menu.name = data.menuName
    if (customPath.includes(menu.path)) return null
    if (menu.children && menu.children.length > 0) {
        menu.type = 'menu'
        menu.isMenu = true
        menu.filter = menu.query
        menu.children.forEach(it => {
            resetMenu(it)
        })
    } else {
        menu.filter = menu.query
        menu.type = 'item'
    }
    return menu
}
const resetCustomMenu = (data, obj) => {
    let menu = data
    let o = obj
    if (customPath.includes(menu.path)) {
        o[menu.path] = 1
    }
    if (menu.children && menu.children.length > 0 && customPath.includes(menu.path)) {
        menu.children.forEach(it => {
            resetCustomMenu(it, o)
        })
    }
    return o
}
const copyNavData = (navData, name, filter) => {
    return Object.assign({}, navData, { menuId: uuid(), name: name, path: navData.path + (filter ? '/_' + btoa(filter) : ''), filter: filter, children: null });
}

function getOrder(id, data) {
    let menu = data.filter(it => it.menuId == id)
    let order = null
    if (menu[0].parentId) {
        order = getOrder(menu[0].parentId, data)
    } else {
        order = menu[0].orderNum
    }
    return order
}
class PermissionManager {
    _permissions = null;
    _permissionMap = {};
    _menuMap = {};
    _permissionTree = null;
    _permissionmenuTree = []
    _permissioncustomMenu = {}
    static _inst = null;
    static getInstance() {
        if (!PermissionManager._inst) PermissionManager._inst = new PermissionManager();
        return PermissionManager._inst;
    }

    static updatePermissions(permissions) {
        PermissionManager.getInstance().updatePermissions(permissions);
    }
    static checkPermission(key) {
        return PermissionManager.getInstance().checkPermission(key);
    }
    static checkPermissioncustomMenu(key) {
        return PermissionManager.getInstance().checkPermissioncustomMenu(key);

    }
    static getPermission(key) {
        return PermissionManager.getInstance().getPermission(key);
    }
    static getNavData(key, filter) {
        return PermissionManager.getInstance().getNavData(key, filter);
    }
    static resetNavigator(navConfig, root) {
        return PermissionManager.getInstance().resetNavigator(navConfig, root);
    }
    static getMenu(path) {
        return PermissionManager.getInstance().getMenu(path);
    }
    static getTabButton(menuId, buttons) {
        return PermissionManager.getInstance().getTabButton(menuId, buttons);
    }
    static getPath(id) {
        return PermissionManager.getInstance().getPath(id);
    }

    static getSubMenu(path) {
        return PermissionManager.getInstance().getSubMenu(path);
    }
    static getDestMenu() {
        return PermissionManager.getInstance().getDestMenu();
    }
    static getMenuOrder(id) {
            return PermissionManager.getInstance().getMenuOrder(id);
        }
        // static getApplicationAdress() {
        //     return PermissionManager.getInstance().getApplicationAdress();
        // }
    static getManageAdress() {
        return PermissionManager.getInstance().getManageAdress();
    }
    updatePermissions(permissions) {
        // return;
        this._permissions = permissions;
        const { buttons, menus } = permissions
        const tree = [];
        const nodes = {};
        for (const permission of buttons) {
            this._permissionMap[permission.entityCode] = 1
            if (permission.batch == 1) {
                this._permissionMap[permission.entityCode + '/' + permission.info + '+'] = 1

            }
            this._permissionMap[permission.entityCode + '/' + permission.info] = 1
        }
        this._permissionmenuTree = menus.filter(it => { return it.menuType != 'M' })
        this._permissionmenuTree.forEach(menu => {
                menu.path = menu.path + (menu.query ? '/_' + btoa(menu.query) : '')
                menu.filter = menu.query
                this._permissionMap[menu.path] = 1
                this._menuMap[menu.path] = menu;
            })
            // console.log(this._permissionmenuTree)
            // for (const permission of permissions) {
            //     delete permission.children;
            //     const nodeId = permission.menuId;
            //     const parentId = permission.parentId;
            //     let node = nodes[nodeId];
            //     if (node) Object.assign(node, permission);
            //     else nodes[nodeId] = node = permission;
            //     if (parentId == 0) {
            //         tree.push(permission);
            //     } else {
            //         let pnode = nodes[parentId];
            //         if (!pnode) {
            //             nodes[parentId] = pnode = {menuId:parentId, children:[]};
            //         }
            //         if (!pnode.children) pnode.children = [];
            //         pnode.children.push(node);
            //     }
            // }
            // this._permissionMap = resetNodeMap(tree);
        this._permissionTree = tree;
    }
    getTabButton(menuId, buttons) {
        let menu = this._permissionmenuTree.filter(it => it.menuId == menuId)[0]
        if (menu.filterButton) {
            let pb = buttons
            let fb = JSON.parse(menu.filterButton)
            let fo = {}
            fb.forEach(it => {
                fo[it.code + it.name] = it
            })
            pb.forEach(it => {
                if (it.children) {
                    let d = false
                    it.children.forEach(b => {
                        b.name = fo[b.code + b.name].showname || b.name;
                        b.d = fo[b.code + b.name] ? fo[b.code + b.name].checked : true
                        if (b.d) {
                            d = true
                        }

                    })
                    it.d = d
                } else {
                    it.name = fo[it.code + it.name] ? (fo[it.code + it.name].showname || it.name) : it.name
                    it.d = fo[it.code + it.name] ? fo[it.code + it.name].checked : true;
                }

            });
            pb.forEach(it => {
                if (it.children) {
                    it.children = it.children.filter(it => it.d)
                }
            })
            pb = pb.filter(it => it.d)
            return pb
        } else {
            return buttons
        }
    }
    checkPermission(key) {
        if (!key) {
            return true
        }
        key = key.replace(/\/$/, '');
        // return !!this._permissionMap[key];
        return true
    }
    checkPermissioncustomMenu(key) {
        if (!key) {
            return true
        }
        key = key.replace(/\/$/, '');
        return !!this._permissioncustomMenu[key];
        // return true
    }
    getPermission(key) {
        key = key.replace(/\/$/, '');
        return this._permissionMap[key];
    }
    getNavData(key, query) {
        key = key.replace(/\/$/, '');
        const data = this._menuMap[key];
        if (!data) return null;
        if (data instanceof Array) {
            for (const d of data) {
                if (d.query == query) {
                    return d;
                }
            }
        } else {
            return data;
        }
    }
    resetNavigator(navConfig, root) {
        let datas = handleTree(this._permissionmenuTree.filter(it => it.menuType == 'C' && it.status == "0" && it.systemId == '136'&& it.pcode != 'lms'), "menuId");
        let menu = [];
        let o = {}
        for (const navData of datas) {
            let data = resetMenu(navData)
            let custom = resetCustomMenu(navData, {})
            if (data) {
                menu.push(data)
            }
            o = Object.assign(o, custom)
        }
        this._permissioncustomMenu = o
            // console.log(resetCustomMenu(datas,{}))
            // for (const navData of navConfig) {
            //     let np = navData.path.replace(/\/{2,}/g, '/').replace(/\/list/, '');
            //     let permissions = this.getPermission(np);
            //     if (permissions) {
            //         if (!(permissions instanceof Array)) permissions = [permissions];
            //         for (const permission of permissions) {
            //             if (permission.menuType == 'M' && permission.path)
            //                 continue;
            //             const n = copyNavData(navData, permission.menuName, permission.query);
            //             if (navData.children && navData.children.length) {
            //                 n.children = this.resetNavigator(navData.children, np);
            //             }
            //             datas.push(n);
            //         }
            //     }
            // }
        return menu;
        return baseConfig
    }
    getManageAdress() {
            let path = '/'
            console.log(this.resetNavigator())
            path = this.resetNavigator()[0].children ? this.resetNavigator()[0].children[0].path : this.resetNavigator()[0].path
            return path
        }
        // getApplicationAdress() {
        //     this.resetNavigator()
        //     let path = ''
        //     path =this._permissioncustomMenu['/defaultNavigator']?'/defaultNavigator':'/teachNavigator'
        //     console.log(this._permissioncustomMenu)
        //     return path
        // }
    getMenu(path) {

        let menu = this._permissionmenuTree.filter(it => it.path == path)
        return menu
    }
    getPath(id) {
        let path = this._permissionmenuTree.filter(it => it.menuId == id)[0].perms
        return path
    }
    getMenuOrder(id) {
        let order = getOrder(id, this._permissionmenuTree)
        return order
    }
    getDestMenu() {
        let datas = this._permissionmenuTree.filter(it => it.menuType == 'C' && it.status == "0" && it.systemId == '136' && it.isCache == '1'&&it.pcode!='lms')
        return datas
    }
    getSubMenu(path) {
        let submenu = []
        let fmenu = this.getMenu(path)
        if (fmenu.length > 0) {
            submenu = this._permissionmenuTree.filter(it => it.parentId == fmenu[0].menuId && it.status == '0' && it.menuType == 'F')
        }
        return submenu
    }
}

export default PermissionManager;